import apis from "../../../api/apis";
import { APIResponseType } from "../../../config/enumApiResponseTypes";
import { IBaseModel } from "../../../interfaces/base";
import { IPartnerStoreRequestModel } from "../../../interfaces/store";
import {
  GET_STATUS_ERROR,
  GET_STATUS_LOAD,
  GET_STATUS_SUCCESS,
  SET_STATUS_ERROR,
  SET_STATUS_LOAD,
  SET_STATUS_SUCCESS,
} from "../types";

//get status
export const getStatus = (data: IBaseModel) => async (dispatch: any) => {
  try {
    dispatch({
      type: GET_STATUS_LOAD,
    });

    const res = await apis.Stores.getStoreStatus(data);
    //console.log("data")

    //console.log(res.ResponseData.StoreStatus)

    if (res.ResponseType === APIResponseType.Success) {
      dispatch({
        type: GET_STATUS_SUCCESS,
        data: res.ResponseData.StoreStatus,
      });
    } else {
      dispatch({
        type: GET_STATUS_ERROR,
        data: null,
      });
    }
  } catch (error) {
    console.log(error);
    dispatch({
      type: GET_STATUS_ERROR,
      data: error,
    });
  }
};

//set status
export const setStatus =
  (data: IPartnerStoreRequestModel) => async (dispatch: any) => {
    try {
      dispatch({
        type: SET_STATUS_LOAD,
      });

      const res = await apis.Stores.setStoreStatus(data);
      //console.log("data")

      //console.log(data)
      dispatch({
        type: SET_STATUS_SUCCESS,
        data: res,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: SET_STATUS_ERROR,
        data: error,
      });
    }
  };
